<template>
  <div
      class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
  >
    <div
        class="bg-white rounded-lg shadow-lg w-3/4 max-w-4xl p-6 overflow-y-auto max-h-screen"
    >
      <h2 class="text-xl font-semibold mb-4">Edit Roles</h2>

      <!-- AG Data Grid for Tags -->
      <ag-grid-vue
          class="ag-theme-balham w-full h-96"
          :rowData="tags"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowDragManaged="true"
          :animateRows="true"
          :components="gridComponents"
          :gridOptions="gridOptions"
          rowSelection="single"
          @grid-ready="onGridReady"
      ></ag-grid-vue>

      <!-- Add Role Button -->
      <button
          @click="addTag"
          class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 mt-4"
      >
        Add Tag
      </button>

      <!-- Save and Cancel Buttons -->
      <div class="flex justify-end space-x-4 mt-6">
        <button
            @click="cancel"
            class="px-4 py-2 rounded border hover:bg-gray-100"
        >
          Cancel
        </button>
        <button
            @click="save"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue3";
import DeleteButtonRenderer from "@/components/common/DeleteButtonRenderer.vue";

export default {
  name: "TagConfigEditor",
  components: {
    AgGridVue,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tags: [], // Local copy of roles
      initialTags: [],
      gridComponents: {
        DeleteButtonRenderer
      },
      columnDefs: [
        {headerName: "ID", field: "id", editable: false, rowDrag: true},
        {headerName: "Tag", field: "name", editable: true},
        {
          headerName: "Status",
          field: "status",
          editable: true
        },
        {
          headerName: "Actions",
          cellRenderer: "DeleteButtonRenderer",
          cellRendererParams: {
            onClicked(params) {
              params.api.applyTransaction({remove: [{role_title: params.node.id}]});
            }
          }
        },
      ],
      defaultColDef: {
        resizable: true,
        sortable: false,
      },
      gridOptions: {
        getRowId(row) {
          return row.data.id;
        }
      },
      gridApi: null
    };
  },
  created() {
    this.tags = [...this.params.value];
    this.initialTags = [...this.tags];
  },
  methods: {
    getValue() {
      return this.tags;
    },
    isPopup() {
      return true;
    },
    onGridReady(params) {
      this.gridApi = params.api;
    },
    addTag() {
      // push a tag with a random six-character ID, a blank name, and a status of "live" to the tags array
      this.tags.push({id: Math.random().toString(36).substring(2, 8), name: "", status: "live"});
    },
    save() {
      const reorderedTags = [];
      this.gridApi.forEachNodeAfterFilterAndSort((node) => {
        reorderedTags.push(node.data);
      });
      this.tags = reorderedTags;
      this.params.stopEditing();
    },
    cancel() {
      this.tags = [...this.initialTags];
      this.params.stopEditing();
    },
  },
};
</script>

<style scoped>
/* Optional custom styles can be added here */
</style>
